/* eslint-disable jsx-a11y/anchor-is-valid */
import { globalVariables } from "helper/globalVariables";
import { useMediaQuery } from "react-responsive";
import { ActionButton } from "shared/Components/actionButton/ActionButton";
import { useNavigate } from "react-router-dom";
import MultiSelectDropdown from "shared/Components/multiselectDropdown";
import { ROLE } from "helper/utility";

import moment from "moment";
import Loader from "shared/Components/loader";
import { isEditable } from "@testing-library/user-event/dist/utils";

const threeDotData = [globalVariables.edit, globalVariables.delete];

export const UserDetailCard = ({
  userDetail,
  handleUpdateRole,
  userRoles,
  loading,
  editable = true,
}) => {
  const isSmallMobile = useMediaQuery({ query: "(max-width: 320px)" });
  const navigate = useNavigate();

  const onSelectOption = (data) => {
    if (data?.role?.includes("Judge")) {
      navigate(`/admin/manage/users/${data?.authId}/Judge/update`);
    } else if (data?.user?.role?.includes("Host")) {
      navigate(`/admin/manage/users/${data?.authId}/Host/update`);
    } else {
      navigate(`/admin/manage/users/${data?.authId}/Member/update`);
    }
  };

  return (
    <div class={`bg-white ${isSmallMobile ? "w-70 pb-2" : "w-80"} h-[540px]`}>
      <div class="flex justify-start flex-col mt-5 pb-3">
        <>
          <div className="flex flex-col mb-4">
            <span className="text-xs text-gray-600">
              {globalVariables.name}
            </span>
            <span className="text-md">{userDetail.name}</span>
          </div>
          <div className="flex flex-col mb-4">
            <span className="text-xs text-gray-600">
              {globalVariables.email}
            </span>
            <span className="text-md">{userDetail.email}</span>
          </div>
          <div className="flex flex-col mb-4">
            <span className="text-xs text-gray-600">
              {globalVariables.phoneNumber}
            </span>
            <span className="text-md">{userDetail.phone_number}</span>
          </div>
          <div className="flex flex-col mb-4">
            <span className="text-xs text-gray-600">
              {globalVariables.memberSince}
            </span>
            <span className="text-md">
              {userDetail.createdAt
                ? moment(userDetail.createdAt).format("MMM YYYY")
                : "-"}
            </span>
          </div>
          <div className="flex flex-col mb-4">
            <span className="text-xs text-gray-600">
              {globalVariables.address}
            </span>
            <span className="text-md">{userDetail.location_address}</span>
          </div>

          <div className="flex flex-col mb-4">
            <span className="text-xs text-gray-600">
              {globalVariables.role}
            </span>
            <div className="flex mt-2">
              {editable ? (
                <MultiSelectDropdown
                  disabled={loading}
                  dropdownOptions={
                    loading
                      ? []
                      : userRoles?.map((userRole) =>
                          userDetail?.role?.includes(userRole?.title)
                            ? {
                                ...userRole,
                                isSelected: true,
                              }
                            : { ...userRole }
                        )
                  }
                  placeholder={
                    loading ? (
                      <Loader stroke="text-gradient-500" />
                    ) : (
                      userDetail?.role?.join(", ") || ROLE.Member
                    )
                  }
                  width={"w-[150px]"}
                  className={loading ? "h-10" : "h-auto"}
                  onChange={(updateOptions) => {
                    handleUpdateRole({
                      authId: userDetail?.authId,
                      roles: updateOptions
                        ?.filter((option) => option?.isSelected)
                        ?.map((options) => options?.title),
                    });
                  }}
                />
              ) : (
                <span>
                  {userDetail?.role ? userDetail?.role?.join(", ") : "-"}
                </span>
              )}
              {/* {loading ? (
                <Loader stroke="text-gradient-500" />
              ) : ( */}

              {/* )} */}
            </div>
          </div>

          {editable && (
            <div className="flex flex-col mb-4">
              <span className="text-xs text-gray-600">
                {globalVariables.action}
              </span>

              <div className="flex mt-2">
                <ActionButton
                  actionButtonOptions={threeDotData}
                  width={"w-[150px]"}
                  onClickOption={() => onSelectOption(userDetail)}
                />
              </div>
            </div>
          )}
        </>
      </div>
    </div>
  );
};
